<script lang="ts" setup>
import type { ChildElement } from '~~/server/api/faq/index'

export interface PagesFaqCategories {
    data: ChildElement[]
}

const props = defineProps<PagesFaqCategories>()
</script>
<template>
  <div class="row">
    <template
      v-for="(category, index) in props.data"
      :key="index"
    >
      <Tracker :data="{ position: category.title }">
        <div class="col-12 col-md-6 col-lg-4 mb-8">
          <h2 class="mb-6">
            {{ category.title }}
          </h2>
          <FaqListQuestions
            v-if="category.faq.length > 0"
            :faq="category.faq"
            :category-slug="category.slug"
          />

          <FaqListChildren
            v-if="category.children.length > 0"
            :children="category.children"
          />

          <VNuxtLink
            :to="{
              name: 'faq-category',
              params: { id: category.slug },
            }"
            class="d-flex align-items-center text-black fs-md-bigger"
            :label="$t('Zobraziť všetko')"
            :aria-label="`${$t('Zobraziť všetko')} ${category.title}`"
            :aria-labelledby="`${$t('Zobraziť všetko')} ${category.title}`"
          >
            {{ $t('Zobraziť všetko') }}
            <svg
              aria-hidden="true"
              class="d-block ms-2"
              width="6"
              height="11"
            >
              <use xlink:href="#angle-right" />
            </svg>
          </VNuxtLink>
        </div>
      </Tracker>
    </template>
  </div>
</template>
